var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.hasObjectStores)?_c('div',[_c('small',[_vm._v("Filter by storage source:")]),_vm._v(" "),_c(_setup.FilterObjectStoreLink,{attrs:{"object-stores":_setup.selectableObjectStores,"value":_setup.localValue},on:{"change":_setup.onChange}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }